// Utility Function For Downloading a file with javascript.

const downloadFile = async (url: string, name: string) => {
	const link = document.createElement('a')
	link.href = url
	link.download = name
	link.target = '_blank'
	link.click()
}

export default downloadFile
